import React, { useEffect, useState } from 'react'
import { Box, Typography, withStyles } from '@material-ui/core'
import { Icon } from '@iconify/react'
import styles from './styles'
import { getDrawerImages } from '../data'
import { useLocation, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import clsx from 'clsx'
import { SectionPopover } from '../../../index'
import { courseRemoveCard, getCardAction } from 'src/reducers/card/action'
import { isAnswerItemTypeResultCard } from 'src/model/card' // Assuming this is needed for result card check

import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { ButtonData, ButtonType, ButtonActionType } from 'src/model/button'
import findNextCardAfterDeletion from 'src/hooks/findNextCardAfterDeletion'
import { getCardSuccess } from 'src/reducers/card/action'
import { useParams } from 'react-router-dom'
const CardTitleTextfield = props => {
  const { classes, provided, card, setSections, sections } = props
  const history = useHistory()
  const dispatch = useDispatch()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const { id, page, subPage } = useParams()
  const cardId = subPage
  const course = useSelector(state => state.course.course)
  const [hovered, setHovered] = useState(false)
  const currentCard = useSelector(state => state.card.currentCard)
  const [selected, setSelected] = useState(
    cardId?.toString() === card?.id?.toString() ||
      currentCard?.id?.toString() === card?.id?.toString(),
  )

  useEffect(() => {
    setSelected(
      cardId?.toString() === card?.id?.toString() ||
        currentCard?.id?.toString() === card?.id?.toString(),
    )
  }, [cardId, currentCard])
  const [drawerImage, setDrawerImage] = useState(
    getDrawerImages(card.type, selected),
  )
  const handleMouseEnter = () => {
    setHovered(true)
  }
  const handleMouseLeave = () => {
    setHovered(false)
  }

  useEffect(() => {
    setDrawerImage(getDrawerImages(card.type, selected))
  }, [cardId, card, window.location.pathname, currentCard, selected])

  const redirectToCard = card => {
    dispatch(
      getCardAction(null, () => {
        setTimeout(() => {
          if (isAnswerItemTypeResultCard(card.type)) {
            history.push(`/mini-course/${course.id}/page/completion`)
            return
          }
          history.push(`/mini-course/${course.id}/page/${card.id}`)
          dispatch(getCardAction(card.id))
        }, 1000)

        clearTimeout()
      }),
    )
  }
  const [openPopup, setOpenPopup] = React.useState(null)
  const handleClosePopup = () => {
    setOpenPopup(null)
  }

  const handleDeletePopup = event => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.ERROR,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              'Cancel',
              ButtonActionType.NO,
              e => {
                dispatch(messageBoxHideAction())
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              'Delete',
              ButtonActionType.DELETE,
              e => {
                const nextCard = findNextCardAfterDeletion(card.id, sections)
                let newSections = sections
                newSections = newSections.map(section => {
                  section.cards = section.cards.filter(
                    sectionCard => sectionCard.id !== card.id,
                  )
                  if (section.cards.length === 0) {
                    return null
                  } else return section
                })

                newSections = newSections.filter(
                  section => section !== null && section.cards.length > 0,
                )

                // Navigate to appropriate page after deletion
                dispatch(
                  courseRemoveCard(course.id, card.id, () => {
                    setSections(newSections)
                  }),
                )

                if (nextCard) {
                  history.push(`/mini-course/${course.id}/page/${nextCard.id}`)
                  dispatch(getCardAction(nextCard.id))
                } else {
                  dispatch(getCardAction(null))
                  history.push(`/mini-course/${course.id}/page/`)
                }

                dispatch(messageBoxHideAction())
              },
            ),
          ],
          title: 'Delete Page',

          description: 'You are about to delete this page.',
        }),
      ),
    )
  }

  const open = useSelector(state => state.course.sectionDrawerOpen)

  return (
    <Box
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={() => {
        redirectToCard(card)
      }}
      className={clsx({
        [classes.header]: selected == false,
        [classes.headerSelected]: selected == true,
      })}
    >
      {hovered && open ? (
        <span {...provided.dragHandleProps}>
          <Icon icon="icon-park-outline:drag" />
        </span>
      ) : (
        <img src={drawerImage} alt="card-type" width="14px" height="14px" />
      )}
      {card?.title?.length == 0 || card?.title == null ? (
        <Typography
          style={{
            height: open ? '100%' : '0px',
            display: open ? 'block' : 'none',
            overflow: 'hidden',
            fontFamily: 'Inter',
            fontSize: '12px',
            fontWeight: 400,
          }}
        >
          Untitled Page
        </Typography>
      ) : (
        <Typography
          style={{
            height: open ? '100%' : '0px',
            overflow: 'hidden',

            fontFamily: 'Inter',
            fontSize: '12px',
            fontWeight: 400,
            maxWidth: '195px',
            textOverflow: 'ellipsis',
            display: open ? 'block' : 'none',
          }}
        >
          {card.title}
        </Typography>
      )}
      <div
        style={{
          display: open ? 'block' : 'none',

          flexGrow: 1,
        }}
      ></div>
      <Icon
        icon={'eva:more-vertical-fill'}
        style={{
          display: open ? 'block' : 'none',
        }}
        className={classes.moreFillIcon}
        onClick={event => {
          event.stopPropagation()
          setOpenPopup(event.currentTarget)
        }}
      />
      <SectionPopover
        openPopup={openPopup}
        handleClosePopup={event => {
          if (event) {
            event.stopPropagation()
          }
          handleClosePopup()
        }}
        itemData={[
          {
            text: 'Delete Page',
            action: event => {
              if (event) event.stopPropagation()
              handleDeletePopup()
            },
          },
        ]}
      />
    </Box>
  )
}

export default withStyles(styles)(CardTitleTextfield)
